import moment from 'moment'

export function formatDate(dateStr: string | null): string {
  if (!dateStr) return '-'
  return moment(dateStr).format('YYYY/MM/DD HH:mm')
}
